<template>
  <div>
    <div class="huge-triangle"></div>
    <div class="block-screen" v-if="loading"><i class="fa fa-spinner fa-spin"></i></div>
    <modal v-if="hasErrors" @close="closeModal" title="Erro ao resetar a senha" 
      body="Ocorreu uma falha ao tentar resetar a senha. 
        Verifique o seu email ou se o link enviado por email está correto.">
    </modal>

    <modal v-if="showSuccess" @close="closeModal" title="Senha alterada com sucesso." 
      body="Retorne para o login e utilize sua nova credencial para efetuar login." type="info">
    </modal>        

    <div class="container login">
      <div class="row">          
        <div class="col-md-7 col-sm-12 block1">
          <img id="logo" src="../assets/images/PTC.png" width="auto" height="81" />
          <h1 style="margin-bottom: 1em;">Resetar senha</h1>

          <transition name="fade1" appear>
            <form id="form-login" role="form">           
              <div class="form-group" :class="{ 'has-error': $v.email.$error }">
                <label for="registeredEmail">Email</label>
                <input type="email" @input="$v.email.$touch()" placeholder="Email *" v-model="email" autofocus>
                <span class="text-danger" v-if="!$v.email.required && $v.email.$dirty">Utilize seu email</span>
                <span class="text-danger" v-if="!$v.email.email && $v.email.$dirty">Digite um email válido.</span>
              </div>
              <div class="form-group" :class="{ 'has-error': $v.password.$error }">
                <label for="password">Senha</label>
                <div class="input-group">
                  <input v-if="!showPassword" type="password" @input="$v.password.$touch()" placeholder="Senha *" v-model="password">
                  <input v-if="showPassword" type="text" @input="$v.password.$touch()" placeholder="Senha *" v-model="password">
                  <span class="input-group-addon" @click="showPassword = !showPassword">
                    <i :class="toggleEyeIcon"></i>
                  </span>
                </div>
                <span class="text-danger" v-if="!$v.password.required && $v.password.$dirty">A senha é obrigatória.</span>
              </div>
              <a class="btn btn-block" @click="resetPassword($v.$invalid)">                
                RESETAR SENHA
                <span v-if="loading">
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
              </a>
              <div class="forgot-password">
                <a class="fancy" @click="goToLogin" href="#">
                  &larr;&nbsp;Retornar para login
                </a>                     
              </div>
            </form>
          </transition>
          <p class="copyright"><a class="fancy" href="http://www.origamieventos.com.br/" target="_blank">© 2025 Origami Eventos e Turismo</a></p>
        </div>
        <div class="col-md-5 hidden-sm hidden-xs block2">
          <img class="logo-origami" src="../assets/images/logo-origami-black.png"  />
          <img class="airplane" src="../assets/images/airplane.jpg"  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Modal from './shared/Modal.vue';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  data: function () {
    return {
      email: '',
      password: '',
      token: '',
      showPassword: false,
      loading: false,
      hasErrors: false,
      showSuccess: false
    }
  },
  components: {
    modal: Modal
  },
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(8), maxLength: maxLength(60) }
  },
  mounted: function () {
    this.token = window.location.hash.replace('#/resetar-senha?token=', '');
  },
  methods: {
    resetPassword: function (validation) {
      if (!validation) {
        this.loading = true;
        const data = {
          token: this.token,
          email: this.email, 
          password: this.password, 
          password_confirmation: this.password
        };
        this.$http.post(`auth/reset`, data)
          .then(response => {
            this.showSuccess = true;
            this.loading = false; 
          })
          .catch(e => {
            this.loading = false;
            this.hasErrors = true;
          }); 
      }
    },
    goToLogin: function () {
      this.$router.push({name: 'login'});
    },
    closeModal: function () {
      this.hasErrors = false;
      this.showSuccess = false;
    }
  },
  computed: {
    toggleEyeIcon: function() {
      return {
        "fa fa-eye": this.showPassword,
        "fa fa-eye-slash": !this.showPassword,
      }
    },
  }
}
</script>

<style lang="scss" scoped>

@import "../../src/assets/css/variables.scss";


.huge-triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 810px solid #fff;
  border-right: 525px solid transparent;

  @include drop-shadow();
}

.login {
  position: relative;
  background-color: #fff;
  margin-top: $baseline * 2; 

  @include box-shadow();

  &:before {
    left: 0;
    position: absolute;
    width: 0;
    height: 0;
    border-top: 108px solid $brand-color;
    border-right: 70px solid transparent;        

  }
}

#logo {
  margin: 3rem 0 0;
}

.block1 {
  padding: 0 50px;

  @media (min-width: 768px) {
    padding: 0 100px;
  }     

  @media (min-width: 992px) {
    padding: 0 70px;
  }      

  @media (min-width: 1200px) {
    padding: 0 100px;
  }    
}

.forgot-password {
  margin-bottom: $baseline;
  text-align: right;
}

.block2 {
  height: 634px;
  padding-right: 0;
  padding-left: 0;
}

.login-options {

  display: block;
  margin-bottom: $baseline;

  @media (min-width: 535px) {
    display: flex; 
    flex-direction: row;
    justify-content: space-between; 
    margin-bottom: 0;
    width: inherit;
  }
}

.logo-origami {
  position: absolute;
  z-index: 1;
  right: 0;
  padding: $baseline $baseline 0 0;
  width: 188px;
  height: auto;
}

.airplane {
  height: inherit;
  object-fit: cover;
  width: 404.16px;
  opacity: .7;
  
  @media (min-width: 1200px) {
    width: 488px;
  }
}

form {
  margin-bottom: 1rem * 2;
}

#form-forgot > .form-group {
  margin: 4.16rem 0;
}


</style> 




// WEBPACK FOOTER //
// src/components/ResetPassword.vue